module.exports = __webpack_public_path__ + "static/media/Trading_Up_Mobile_Banner_STAKE@1x.48fc6155.webp";